export default "__VITE_ASSET__gW3cLTZH__"